import type { SupportedLocale } from "@/config/locale-config";

/**
 * Strapi content is authored for the public marketing site, so its relative
 * links have to be resolved against that host rather than this app's domain.
 */
const marketingOriginByLocale: Record<SupportedLocale, string> = {
	sv: "https://leabank.se",
	fi: "https://leabank.fi",
	no: "https://leabank.no",
};

/** Returns null for anything that is not a plain http(s) or site-relative link. */
export const resolveMarketingHref = (
	value: string | null | undefined,
	locale: SupportedLocale
): string | null => {
	const raw = value?.trim();

	if (!raw) return null;
	if (raw.startsWith("//")) return null;
	if (raw.startsWith("/")) return `${marketingOriginByLocale[locale]}${raw}`;
	if (/^https?:\/\//i.test(raw)) return raw;

	return null;
};
